module.exports = __webpack_public_path__ + "img/resultados-q1-2023-oficial.501b6371.jpg";